import indexLifecycle from "@/controllers/estimates/indexLifecycle";
import indexDataMethods from "@/controllers/estimates/indexDataMethods";
import indexPresentationMethods from "@/controllers/estimates/indexPresentationMethods";
import moment from "moment";
import createManagementShortDateMethods from "@shared/createManagementShortDateMethods.cjs";

const shortDateMethods = createManagementShortDateMethods({
  DateFormatter: moment,
});

export default {
  data() {
    return {
      activeTab: indexDataMethods.resolveActiveTab(this.$route),
      dateRange: indexDataMethods.resolveDateRange(this.$route),
      page: indexDataMethods.resolvePage(this.$route),
      pageSize: 50,
      total: 0,
      estimates: [],
      deletingEstimateId: null,
      estimateLoadRequestId: 0,
    };
  },
  ...indexLifecycle,
  methods: {
    ...shortDateMethods,
    ...indexDataMethods,
    ...indexPresentationMethods,
  },
};
